// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ReloadOutlinedSvg from "@fishx/icons-svg/es/asn/ReloadOutlined";
import FishxIcon from '../components/FishxIcon';

var ReloadOutlined = function ReloadOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ReloadOutlinedSvg
  }));
};

ReloadOutlined.displayName = 'ReloadOutlined';
export default React.forwardRef(ReloadOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ReloadOutlined.js
// module id = 3993
// module chunks = 0